<template>
	<div>
		<CHead :oHead="Head"></CHead>
		<div class="row justify-content-center mt-3">
			<div class="col-12 col-sm-12 col-md-6 col-lg-6">
				<div class="card card-01">
					<div class="row justify-content-end mt-2">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12">
							<CLoader :pConfigLoad="ConfigLoad">
								<template slot="BodyFormLoad">
									<div class="row" v-if="ListaSueldos.length>0">
										<div class="col-6 col-sm-6 col-md-6 col-lg-6 px-5">
											<div class="row pb-2">
												<div class="col-12 col-sm-12 col-md-12 col-lg-12">
													<h2 class="text-info text-center">Mano de Obra Técnico</h2>
												</div>
											</div>
											<div class="form-group form-row pb-2">
												<div class="col-12 col-sm-12 col-md-12 col-lg-12 d-flex justify-content-center">
													<button @click="GetSueldo(ListaSueldos[0])" type="button" data-toggle="modal" data-target="#ModalCalculadora" data-backdrop="static" class="btn btn-01 cal"> Calculadora</button>
												</div>
											</div>
											<div class="form-group form-row pb-2">
												<div class="col-12 col-sm-12 col-md-6 col-lg-6">
													<label >Mano de Obra / Hora *</label>
													<vue-numeric :minus="false" class="form-control" currency="$" separator="," :precision="0" v-model="ListaSueldos[0].ManoObra"></vue-numeric>
												</div>
												<div class="col-12 col-sm-12 col-md-6 col-lg-6">
													<label>Burden / Hrs *</label>
													<vue-numeric :disabled="BurdenDisabled" :minus="false" class="form-control" currency="$" separator="," :precision="0" v-model="ListaSueldos[0].Burden"></vue-numeric>
												</div>
											</div>
											<div class="form-group form-row">
												<div class="col-12 col-sm-12 col-md-6 col-lg-6">
													<label >Hors. Trab./Semanal *</label>
													<vue-numeric :minus="false" class="form-control" currency="" separator="," :precision="0" v-model="ListaSueldos[0].HorasTrabajadas"></vue-numeric>
												</div>
												<div class="col-12 col-sm-12 col-md-6 col-lg-6">
													<label>Hrs. Produc./Semanal *</label>
													<vue-numeric :minus="false" class="form-control" currency="" separator="," :precision="0" v-model="ListaSueldos[0].HorasProductivas"></vue-numeric>
												</div>
											</div>
										</div>
										<div class="col-6 col-sm-6 col-md-6 col-lg-6 px-5">
											<div class="row pb-2">
												<div class="col-12 col-sm-12 col-md-12 col-lg-12">
													<h2 class="text-info text-center">Mano de Obra Ayudante</h2>
												</div>
											</div>
											<div class="form-group form-row pb-2">
												<div class="col-12 col-sm-12 col-md-12 col-lg-12 d-flex justify-content-center">
													<button @click="GetSueldo(ListaSueldos[1])" type="button" data-toggle="modal" data-target="#ModalCalculadora" data-backdrop="static" class="btn btn-01 cal"> Calculadora</button>
												</div>
											</div>
											<div class="form-group form-row pb-2">
												<div class="col-12 col-sm-12 col-md-6 col-lg-6">
													<label >Mano de Obra / Hora *</label>
													<vue-numeric :minus="false" class="form-control" currency="$" separator="," :precision="0" v-model="ListaSueldos[1].ManoObra"></vue-numeric>
												</div>
												<div class="col-12 col-sm-12 col-md-6 col-lg-6">
													<label>Burden / Hrs *</label>
													<vue-numeric :disabled="true" :minus="false" class="form-control" currency="$" separator="," :precision="0" v-model="ListaSueldos[1].Burden"></vue-numeric>
												</div>
											</div>
											<div class="form-group form-row">
												<div class="col-12 col-sm-12 col-md-6 col-lg-6">
													<label >Hors. Trab./Semanal *</label>
													<vue-numeric :minus="false" class="form-control" currency="" separator="," :precision="0" v-model="ListaSueldos[1].HorasTrabajadas"></vue-numeric>
												</div>
												<div class="col-12 col-sm-12 col-md-6 col-lg-6">
													<label>Hrs. Produc./Semanal *</label>
													<vue-numeric :minus="false" class="form-control" currency="" separator="," :precision="0" v-model="ListaSueldos[1].HorasProductivas"></vue-numeric>
												</div>
											</div>
										</div>
									</div>
									<div class="row mt-3">
										<div class="col-6 col-sm-6 col-md-6 col-lg-6 px-5">
											<div class="row pb-2">
												<div class="col-12 col-sm-12 col-md-12 col-lg-12">
													<h2 class="text-info text-center">Vehículos</h2>
												</div>
											</div>
											<div class="form-group form-row pb-2">
												<div class="col-12 col-sm-12 col-md-6 col-lg-6">
													<label >Costo ($/km) *</label>
													<vue-numeric v-model="ListaVehiculos[0].Costo" :minus="false" class="form-control" currency="$" separator="," :precision="0"></vue-numeric>
												</div>
											</div>
										</div>
									</div>
								</template>
							</CLoader>
						</div>
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 text-right pt-3">
							<button @click="Regresar" type="button" class="btn btn-04 ban mr-2">Cancelar</button>
                        	<button @click="Guardar" type="button" class="btn btn-01">Guardar</button>&nbsp;
						</div>
					</div>
				</div>
            </div>
		</div>
		<Modal
			:TipoM="2"
			:size="'modal-sm'"
			:Showbutton="false"
			:NameModal="'ModalCalculadora'"
			:Nombre="'Calculadora'"
		>
			<template slot="Form">
				<Calculo :Calculadora="Calculadora" :Sueldo="Sueldo"></Calculo>
			</template>
		</Modal>
		<!-- <div class="row justify-content-center">
			<div class="col-md-6 col-lg-5">
				<Clist :regresar="true" :Nombre="NameList" :Filtro="Filtro" :isModal="EsModal" :pShowBtnAdd="false" :ShowHead="false" :pConfigLoad="ConfigLoad">
					<template slot="header">
						<tr>
							<th>Concepto</th>
							<th>Monto</th>
							<th>Acciones</th>
						</tr>
					</template>
					<template slot="body">
						<tr v-for="(item,index) in ListaSueldos" :key="index">
							<td>{{EvalConcepto(item.Tipo)}}</td>
							<td>${{Number(item.Cantidad ).toLocaleString('es-MX')}}</td>
							<td>
								<Cbtnaccion :PBtndelete="false" :isModal="EsModal" :Id="item.IdSueldo" :IrA="FormName"></Cbtnaccion>
							</td>
						</tr>
					</template>
				</Clist>
				<Modal :size="size" :Nombre="NameForm" :poBtnSave="oBtnSave">
                    <template slot="Form">
                    	<Form :NameList="NameForm"  :poBtnSave="oBtnSave"></Form>
                    </template>
                </Modal>
			</div>
		</div> -->
	</div>
</template>

<script>
import Modal from '@/components/Cmodal.vue';
import Clist from '@/components/Clist.vue';
import Cbtnaccion from '@/components/Cbtnaccion.vue';
import Form from '@/views/catalogos/sueldos/Form.vue';
import CHead from "@/components/CHead.vue";
import Calculo from '@/views/catalogos/sueldos/Calculadora.vue';
export default {
	name:'listsueldos',
	components:{
		Modal,
        Clist,
        Cbtnaccion,
        Form,
        CHead,
		Calculo
	},
	data() {
		return {
			FormName:'sueldos',
			EsModal:true,
			CloseModal:true,
			NameList:"Sueldos",
            NameForm:"Sueldos",
            urlApi:"sueldo/get",
            ListaSueldos:[],
			ListaVehiculos:[],
            ListaHeader:[],
			Filtro:{
				Nombre:'',
            	Placeholder:'Nombre..',
            	TotalItem:0,
            	Pagina:1,
            	Show:false
			},
			oBtnSave:{
				isModal:true,
                disableBtn:false,
                toast:0,
			},
			Head: {
				ShowHead: true,
				Title: "Costo M/O, Burden y Vehículo",
				BtnNewShow: false,
				BtnNewName: "Nuevo",
				isreturn: true,
				isModal: true,
				isEmit: true,
				Url: "",
				ObjReturn: "",
				NameReturn: "Regresar",
				isCuentas: false,
				verFiltroCuentas: false
			},
			ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true,
			},
			Calculadora: { MO: "", HTS: "", HPS: "" },
			Sueldo:{},
			BurdenDisabled:false
		}
	},
	methods: {
		async Lista(){
			this.ConfigLoad.ShowLoader = true;
			await this.$http.get('sueldo/get').then((res) => {
				// console.log(res.data.data);
				this.ListaSueldos =res.data.data.sueldos;
				this.BurdenDisabled=res.data.data.existburden==1 ? true : false;
				this.ListaVehiculos=res.data.data.costovehiculo;
			}).finally(()=>{
				this.ConfigLoad.ShowLoader = false;
			})
		},
		async Guardar(){
			let formData=new FormData();
			formData.set('Sueldos',JSON.stringify(this.ListaSueldos));
			formData.set('CostosVehiculo',JSON.stringify(this.ListaVehiculos));
			await this.$http.post('sueldo/update',formData).then((res) => {
				this.$toast.success('Información Guardada');
				this.bus.$emit('List');
			}).catch((err) => {
				this.$toast.error('Agregue todos los campos');
			})
		},
		EvalConcepto(Concepto){
			let Cadena='';
			switch (Concepto) {
				case '1':
					Cadena="Mano de Obra";
					break;
				case '2':
					Cadena="Burden";
					break;			
				default:
					break;
			};
			return Cadena;
		},
		GetSueldo(Sueldo){
			this.Sueldo=Sueldo;
			this.bus.$emit('Pasar');
		},
		Regresar(){
			this.$router.push({name:'submenuadmon'});
		}
	},
	created() {
		this.bus.$off('List');
		this.bus.$on('List',()=>
        {
            this.Lista();
        });
		this.bus.$off('Regresar');
		this.bus.$on('Regresar',()=>
        {
            this.$router.push({name:'submenuadmon'});
        });
		this.Lista();
	},
}
</script>

<style>

</style>
